// Appel du teleservice Annuaire AMC (organismes complementaires) via le backend.
// Le backend expose TiersPayants/postAppelAnnuaireAMC qui delegue a la lib PARTAGEE
// TransCAM_Library (AnnuaireAMCService.appelAnnuaireAMCWeb, WS SOAP R01Services proxy
// fr.annuaireamc.ws, certificat client IGC-Sante). Cf docs/plans/2026-07-06-qr-code-complementaire-annuaire-amc.md
//
// ATTENTION (metier) : la reponse de l'annuaire porte surtout l'adresse de
// routage DRE (MEL/EDI) et des libelles CSR ; le routage/domaine/hote B2 de
// facfse.Ident.Cc sont, dans le desktop, calcules par la table locale des
// mutuelles (Mutuelles.traite*), pas par cette reponse. On expose donc les
// champs bruts renvoyes et on laisse l'utilisateur valider avant remplissage.
// Code et commentaires en francais sans accents (convention projet).

import config from '../config.js';
import RequestManager from './request.js';

// request = { numeroAMC, typeConvention, csr, domaineConventionnel, horsTP }
// Retour = liste de { routage, domaine, hote, typeConvention, libelle,
//   codeRetour, message, typeAdresse, codeCsr, commentairePs } (casse backend
//   PascalCase 1re lettre : Routage, Domaine, Hote... -> normaliser a l'usage).
export function appelAnnuaireAMC(request) {
    const url = `${config.urlBackEnd}TiersPayants/postAppelAnnuaireAMC`;
    return RequestManager.post(url, request);
}
